import { render, staticRenderFns } from "./AdminAreas.vue?vue&type=template&id=6aa5724b"
import script from "./AdminAreas.vue?vue&type=script&lang=js"
export * from "./AdminAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports